import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { isCommercialFeatureEnabled } from 'dashboard/helper/commercialFeatureHelper';

export const useCommercialFeatures = () => {
  const accountId = useMapGetter('getCurrentAccountId');
  const isFeatureEnabled = useMapGetter('accounts/isFeatureEnabledonAccount');

  const hasRawFeature = feature =>
    isFeatureEnabled.value(accountId.value, feature);
  const hasCore = computed(() => hasRawFeature(FEATURE_FLAGS.BOTZ_CRM_CORE));
  const hasFeature = feature =>
    isCommercialFeatureEnabled({
      accountId: accountId.value,
      feature,
      isFeatureEnabled: isFeatureEnabled.value,
    });

  return { hasCore, hasFeature };
};
